import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import './initial.css';
import { connect } from "react-redux";
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import TitleComponent from '../../components/title/TitleComponent';
import config from '../../config/config';

const FLUX_WITH_TOC = ['full_security', 'light_security', 'full_security_notary'];
const FLUX_WITH_FEA = ['full_security_fea', 'full_fea', 'fea_with_circulation_permission', 'full_fea_with_autocapture',];

const termAndConditions = <div>
    <p>
        Al utilizar el servicio de transferencias digitales de vehículos de Autofact, usted autoriza a AUTOFACT CHILE SPA, RUT N°76.197.647-8, con domicilio en Av. Providencia 2019, oficina 41A, Providencia, Santiago (en adelante, “Autofact”), a recolectar y utilizar los datos personales que entregue con motivo del uso del servicio.
    </p>
    <p>
        Los datos personales que Autofact llegue a recabar serán tratados y protegidos bajo estricta confidencialidad y serán utilizados para el cumplimiento de las siguientes finalidades: permitir el adecuado funcionamiento de la plataforma web y del servicio de transferencia, incluyendo usos como la actualización de la base de datos del Portal, facturación, envío de información relativa a productos o servicios ofrecidos a través de la plataforma web, comunicaciones de marketing, venta directa de productos, realización de estudios de mercado (asegurándose el anonimato de la información) y fines similares incluidos en las categorías señaladas.
    </p>
    <p>
        Autofact puede poner los datos personales en conocimiento de sus entidades relacionadas, filiales y otras sociedades de su grupo empresarial, para efecto de llevar a cabo los tratamientos antes autorizados. Estos datos no serán transferidos a otros terceros salvo mandatarios de Autofact, y en conformidad a lo establecido en la Ley N°19.628 Sobre Protección de la Vida Privada.
    </p>
    <p>
        Autofact podrá poner los datos personales en conocimiento de las autoridades correspondientes, en caso de detectar información o antecedentes de origen fraudulento o ilegal, así como la entrega de documentación falsa, robo de identidad, u otras irregularidades.
    </p>
    <p>
        El tratamiento de estos datos y su posibilidad de rectificación, modificación y eliminación, se regirá según lo dispuesto en la Ley N°19.628 Sobre Protección de la Vida Privada. Para estos efectos, usted puede contactar a Autofact a través del correo electrónico ayuda@autofact.cl.
    </p>
    <p>
        Toda la información contenida en este documento se encuentra sujeta a lo establecido por las políticas generales de uso del sitio web de Autofact y las políticas de privacidad bajo las que opera la organización.
    </p>
</div>;

class Initial extends Component {
    constructor(props) {
        super(props);
        this.textContent = document.getElementsByClassName('content');
        this.type = this.props.stepInfo.type && this.props.stepInfo.type.toLowerCase();
        this.source = this.props.stepInfo.source && this.props.stepInfo.source.toLowerCase();
        this.isEnrollmentType = this.type === 'enrollment';
        this.isTransference = this.source === 'transference';
        this.state = {
            disabled: this.isTransference || this.isEnrollmentType || this.type === 'parent_handwritten',
            hasShadow: true,
        }
        this.handleScroll = this.handleScroll.bind(this);
    }

    handleScroll(event) {
        const marginBottomToEnable = 25;
        if (event.target.scrollTop >= (event.target.scrollHeight - event.target.offsetHeight - marginBottomToEnable)) {
            this.setState({
                disabled: false,
                hasShadow: false,
            });
        } else {
            this.setState({
                hasShadow: true,
            })
        }
    }

    componentDidMount() {
        if (this.textContent && this.textContent.length && (this.isTransference || this.isEnrollmentType || this.type === 'parent_handwritten')) {
            this.textContent[0].addEventListener('scroll', this.handleScroll);
            if (this.textContent[0].scrollTop === this.textContent[0].scrollHeight - this.textContent[0].offsetHeight) {
                this.setState({
                    disabled: false,
                })
            }
        }
    }


    componentWillUnmount() {
        if (this.textContent && this.textContent.length && this.isTransference) {
            this.textContent[0].removeEventListener('scroll', this.handleScroll);
        }
    }


    getUserInfo = () => {
        return (
            <div>
                <p className={'title'}>Información sobre el sistema de firma Autofact</p>
                <p className={'description'}><strong>Estimado/a {this.props.stepInfo.user}</strong>, estás a
                    punto de comenzar
                    el proceso de firma Autofact para el contrato
                    patente {this.props.stepInfo.plate}. Todo este proceso es necesario para dar garantías
                    legales al notario al momento de autorizar el presente contrato. En este proceso
                    tomaremos una
                    foto de tu cédula de identidad por ambos lados, luego capturaremos una foto de tu rostro
                    para hacer una comparación con la cédula e iniciar el reconocimiento facial, y
                    finalmente deberás hacer tu firma manuscrita en la pantalla para finalizar el
                    proceso.</p>
            </div>
        );
    };

    getEnrollmentInfo = () => {
        const checkIcon = <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8121 0.710938H14.4468C14.2554 0.710938 14.0738 0.798828 13.9566 0.949219L5.90385 11.1504L2.04252 6.25781C1.98411 6.18365 1.90966 6.12368 1.82475 6.08241C1.73984 6.04114 1.64669 6.01965 1.55229 6.01953H0.187053C0.0561937 6.01953 -0.016072 6.16992 0.0640061 6.27148L5.41362 13.0488C5.66362 13.3652 6.14408 13.3652 6.39604 13.0488L15.9351 0.960938C16.0152 0.861328 15.9429 0.710938 15.8121 0.710938Z" fill="#701A82"/>
                        </svg>;

        return (
            <div>
                <p className={'subtitle'}>Enrolamiento inicial en el sistema</p>
                
                <p className={'description'}>{this.props.stepInfo.user}, estás a punto de iniciar tu primer proceso de firma digital para transferencias en Autofact. Para otorgar garantías legales al notario al momento de autorizar los contratos, en este primer proceso:</p>
                <p className='list'><span>{checkIcon}</span> Tomaremos una foto de tu cédula de identidad por ambos lados.</p>
                <p className='list'><span>{checkIcon}</span> Capturaremos una foto de tu rostro para realizar un proceso de reconocimiento facial.</p>
                <p className='list'><span>{checkIcon}</span> Deberás hacer tu firma manuscrita en la pantalla.</p>
                <p className={'description'}>En el futuro, solo necesitarás tu firma manuscrita para firmar contratos, sin tener que repetir todo el proceso nuevamente.</p>
            </div>
        );
    };

    getTransferenceInfo = () => {
        const message = [
            <h1 key={'h1-1'}>Información sobre el sistema de firma Autofact</h1>
        ];
        if (this.props.stepInfo.company && this.props.stepInfo.operator && this.props.stepInfo.client) {
            message.push(
                <h2 key={'h2-1'}>
                    Estimado/a <b>{this.props.stepInfo.client}</b>, estás a punto de comenzar el proceso de firma para el <b>contrato de compraventa para el vehículo 
                    patente {this.props.stepInfo.plate}</b>, proceso gestionado por <b>{this.props.stepInfo.operator}</b> en representación de <b>{this.props.stepInfo.company}</b>. Todo este proceso es necesario para dar garantías legales al notario al momento de autorizar el presente contrato.
                </h2>
            );
        } else {
            message.push(
                <span key={'h2-1'}>
                    Estimado/a <b>{this.props.stepInfo.client}</b>, estás a punto de comenzar el proceso de firma para el <b>contrato de compraventa para el vehículo 
                    patente {this.props.stepInfo.plate}</b>. Todo este proceso es necesario para dar garantías legales al notario al momento de autorizar el presente contrato.
                </span>
            );
        }
        const isDirectCustomerService = this.props.stepInfo.company_id && 
            config.directCustomerServiceCompaniesIds.includes(this.props.stepInfo.company_id);

        if (!isDirectCustomerService) {
            message.push(
                <h2 key={'h2-3'}>En este proceso:</h2>
            )
            const items = [
                <li key={'li-1'}>Tomaremos una foto de tu cédula de identidad por ambos lados.</li>,
                <li key={'li-2'}>Capturaremos una imagen de tu rostro para realizar un proceso de reconocimiento facial.</li>
            ];

            if (FLUX_WITH_TOC.includes(this.props.stepInfo.type)) {
                items.push(
                    <li key={'li-3'}>Te solicitaremos información adicional para validar tu identidad.</li>
                );
            }
            if (FLUX_WITH_FEA.includes(this.props.stepInfo.type)) {
                items.push(
                    <li key={'li-7'}>Te solicitaremos información y acciones adicionales para validar tu identidad.
                        <br />
                        <br />
                        <ul>
                            <li key={'li-8'}>Clave Única.</li>
                            <li key={'li-9'}>Número de documento(cédula).</li>
                            <li key={'li-10'}>Preguntas de información personal.</li>
                            <li key={'li-11'}>Creación de contraseña para firmar.</li>
                            <li key={'li-12'}>Validación de clave contra correo registrado.</li>
                        </ul>
                    </li>
                );
            }
            items.push(
                <li key={'li-4'}>Deberás hacer tu firma manuscrita en la pantalla.</li>
            );
            if (this.props.stepInfo.hasStepVideo && this.props.stepInfo.flow !== 'NOTARY_DECLARATION') {
                items.push(
                    <li key={'li-5'}>Deberás grabar un video indicando que estás autorizando el proceso de compraventa.</li>
                );
            } else if (this.props.stepInfo.flow === 'NOTARY_DECLARATION') {
                items.push(
                    <li key={'li-6'}>El sistema te contactará automáticamente con un aprobador en donde deberás manifestar tu conformidad con el proceso de compraventa.</li>
                );
            }
            message.push(
                <ul key={'ul-1'}>
                    {items}
                </ul>
            );
        }

        message.push(
            <hr key={'hr-1'}></hr>,
            <h2 key={'h2-4'}>Términos y condiciones</h2>,
            <div key={'tyc'}>{termAndConditions}</div>
        );
        return message;
    }

    getDocumentInfo = () => {
        let message = (
            <div>
                <p className={'description'}><strong>Estimado/a {this.props.stepInfo.user}</strong>, estás a punto de comenzar el proceso de firma
                    Autofact para los documentos enviados al correo <b>{this.props.stepInfo.mail}</b>. En este proceso será necesario que tomes una
                    foto a tu cédula de identidad por ambos lados sobre una superficie despejada, luego debes tomar una foto de tu rostro para hacer
                    una comparación con la cédula e iniciar el reconocimiento facial, por último, deberás hacer tu firma manuscrita en la pantalla
                    para finalizar el proceso y dejar firmados los documentos.</p>
            </div>
        );
        if (this.props.stepInfo.clientEmail && this.props.stepInfo.company && this.props.stepInfo.operator && this.props.stepInfo.client) {
            const firstMessage = (
                <p className={'description'}>
                    <b>Estimado/a {this.props.stepInfo.client}</b>, estás a punto de comenzar el proceso de firma Autofact
                    para los documentos enviados al correo <b>{this.props.stepInfo.clientEmail}</b>. Este proceso está gestionado
                    por <b>{this.props.stepInfo.operator}</b> en representación de <b>{this.props.stepInfo.company}</b>.
                </p>
            );
            let secondMessage;
            if (this.props.stepInfo.hasStepVideo && this.props.stepInfo.flow !== 'NOTARY_DECLARATION') {
                secondMessage = (
                    <p className={'description'}>
                        En este proceso será necesario que tomes una foto a tu cédula de identidad por ambos lados sobre una superficie
                        despejada, luego debes tomar una foto de tu rostro para hacer una comparación con la cédula e iniciar el reconocimiento
                        facial. A continuación deberás hacer tu firma manuscrita en la pantalla, y para finalizar el proceso y dejar firmados los documentos,
                        deberás grabar un video de aceptación del proceso. Todo este proceso es necesario para dar garantías legales al notario al momento de
                        autorizar los presentes documentos.
                    </p>
                );
            } else if (this.props.stepInfo.flow === 'NOTARY_DECLARATION') {
                secondMessage = (
                    <p className={'description'}>
                        En este proceso será necesario que tomes una foto a tu cédula de identidad por ambos lados sobre una superficie despejada, luego
                        debes tomar una foto de tu rostro para hacer una comparación con la cédula e iniciar el reconocimiento facial. A continuación deberás
                        hacer tu firma manuscrita en la pantalla, y para finalizar el proceso y dejar firmados los documentos, el sistema te contactará automáticamente
                        con la notaría, en donde deberás manifestar tu conformidad con el proceso completo. Todo este proceso es necesario para dar garantías legales al
                        notario al momento de autorizar los presentes documentos.
                    </p>
                );
            } else if (!this.props.stepInfo.hasStepVideo) {
                secondMessage = (
                    <p className={'description'}>
                        En este proceso será necesario que tomes una foto a tu cédula de identidad por ambos lados sobre una superficie despejada, luego
                        debes tomar una foto de tu rostro para hacer una comparación con la cédula e iniciar el reconocimiento facial, y por último, deberás
                        hacer tu firma manuscrita en la pantalla para finalizar el proceso y dejar firmados los documentos. Todo este proceso es necesario
                        para dar garantías legales al notario al momento de autorizar los presentes documentos.
                    </p>
                );
            }
            message = (
                <div>
                    {firstMessage}
                    {secondMessage}
                </div>
            );
        }

        return (
            <div>
                <p className={'title'}>Información sobre el sistema de firma Autofact</p>
                {message}
            </div>
        );
    }

    getInfo = () => {

        if (this.isEnrollmentType || this.type === 'parent_handwritten') {
            return <Col xs={12} className={'enrollment-container content'}>
                        <div className='enrollment'>
                            <TitleComponent bold className={'title'}>Términos y condiciones</TitleComponent>
                            {this.getEnrollmentInfo()}
                        </div>
                    </Col>
        } else if (this.source === 'document') {
            return <Col xs={12} className={'document-container'}>
                        <TitleComponent subtitle bold className={'text-center'}>Términos y condiciones</TitleComponent>
                        {this.getDocumentInfo()}
                    </Col>;
        } else if (this.isTransference) {
            return <Col xs={12} className={'transference-container content'}>
                        <TitleComponent subtitle bold className={'text-center'}>Términos y condiciones</TitleComponent>
                        <div className='transference-content'>{this.getTransferenceInfo()}</div>
                    </Col>;
        }
        return <Col xs={12} className={'userinfo-container'}>
                        <TitleComponent subtitle bold className={'text-center'}>Términos y condiciones</TitleComponent>
                        {this.getUserInfo()}
                    </Col>;
    };

    render() {
        const info = this.getInfo();
        return (
            <div className={'initial page-layout'}>
                <PageWithFooter
                    footer={(
                        <FooterContainer className={`${this.state.hasShadow && this.isTransference && !this.isEnrollmentType && 'shadow-footer'}`}>
                            <MainButton
                                disabled={this.state.disabled}
                                onClick={this.props.nextStep}
                                className={'next-button'}
                            />
                        </FooterContainer>
                    )}
                >
                    {info}
                </PageWithFooter>
            </div>        );
    }
}


const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Initial);
